<template lang="pug">
b-modal(
    v-model="showBottomSheet.show",
    hide-header
    hide-footer
    size="sm"
    squared
    :no-close-on-esc="true"
    content-class="bottom-sheet-modal"
  )
    div.p-3(v-if="showBottomSheet.type === bottomSheetTypes.EXPORT")
      h5.mb-3.font-weight-bold Exportar:
      .block.mb-4.w-100.text-left.cursor-pointer(@click="$emit('setExportType', null); showBottomSheet.show = false" variant="light") 
        b-icon(icon="calendar4-week").mr-2
        | Rango de Fecha
      .block.text-left.cursor-pointer(@click="$emit('setExportType', 'details'); showBottomSheet.show = false" variant="light") 
        b-icon(icon="calendar-plus").mr-2
        | Rango de Fecha con detalle de repuestos
    div.p-3(v-if="showBottomSheet.type === bottomSheetTypes.COTIZACION_NEW")
      h5.mb-3.font-weight-bold Registrar Nueva
      .block.mb-4.w-100.text-left.cursor-pointer(@click="$emit('openModalCotizacionNew'); showBottomSheet.show = false" variant="light") 
        b-icon(icon="file-earmark-plus").mr-2
        | Generar Cotización
      GenerarCotizacion(asClickableDiv quotationType="fullNew")
</template>

<script>
import GenerarCotizacion from './OVActions/Actions/GenerarCotizacion.vue';

export default {
  name: 'BottomSheetModal',
  components: {
    GenerarCotizacion,
  },
  props: {
    showBottomSheet: {
      type: Object,
      required: true,
    },
    bottomSheetTypes: {
      type: Object,
      required: true,
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .bottom-sheet-modal {
  position: fixed !important;
  bottom: 0;
  left: 0;
  right: 0;
  margin: 0;
  width: 100%;
  max-height: 50%;
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
  overflow-y: auto;
  box-shadow: 0 -2px 16px rgba(0,0,0,0.15);
  background: #fff;
  z-index: 1050;
  padding-bottom: env(safe-area-inset-bottom);
}
@media (min-width: 768px) {
  ::v-deep .bottom-sheet-modal {
    left: 50%;
    transform: translateX(-50%);
    width: 400px;
    max-width: 90vw;
    border-radius: 16px;
    bottom: auto;
    top: 20vh;
  }
}
</style>